import React, { useState, useEffect } from 'react'
import { Row, Col } from 'rsuite'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import { cloneDeep, isEmpty } from 'lodash-es'

import { startLoading, doneLoading } from '../../utils/loading'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import ProjectStatusPending from '../../widgets/projectStatus/ProjectStatusPending'
import Notification from './Notification'

// widget
import Profile from '../../widgets/dashboard/Profile'
import ProjectCost from '../../widgets/dashboard/ProjectCost'
import ProposalProjectList from '../../widgets/projectList/ProposalProjectList'
import OngoingProjectList from '../../widgets/projectList/OngoingProjectList'
import AllProject from '../../widgets/dashboard/AllProject'
import WaitScrutinize from '../../widgets/dashboard/WaitScrutinize'
import WaitScreeningInitial from '../../widgets/dashboard/WaitScreeningInitial'
import WaitScreening from '../../widgets/dashboard/WaitScreening'
import WaitScreeningDepartment6 from '../../widgets/dashboard/WaitScreeningDepartment6'
import ContractStatusWait from '../../widgets/dashboard/ContractStatusWait'
import WaitForReviewer from '../../widgets/dashboard/WaitForReviewer'
import ExpertWaitScrutinizeApproval from '../../widgets/dashboard/ExpertWaitScrutinizeApproval'
import ApprovalBudget from '../../widgets/dashboard/ApprovalBudget'
import MultiApproveReviewerGroup from '../../widgets/dataTable/MultiApproveReviewerGroup'
import WaitScrutinizeDep6 from '../../widgets/dashboard/WaitScrutinizeDep6'
import WaitContractCenterReview from '../../widgets/dashboard/WaitContractCenterReview'
import UpDownStreamWidget from '../../widgets/dashboard/UpDownStreamWidget'
import UserDashboardWidget from '../../widgets/dashboard/UserDashboardWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { SaveDashboardSetting, getDashboardSetting } from '../../redux/actions/dashboard'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import pathname from '../../constants/pathname'
import WaitReviewToClose from '../../widgets/dashboard/WaitReviewToClose'

export default function DashboardSettingNew() {
  const [isLoading, setIsLoading] = useState(false)
  const [isSaveLoading, setIsSaveLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [configResult, setConfigResult] = useState([])
  const [isShowConf, setIsShowConf] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()

    sessionStorage.clear()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getDashboardSetting()
      // const response = mockSchema
      if (response?.forms?.dashBoardList) {
        let configObj = []

        response.forms.dashBoardList.forEach((item) => {
          if (item.subForms?.length > 0) {
            configObj.push(
              ...item.subForms.map((subItem) => {
                return { key: subItem.config.key, show: subItem.config.show }
              })
            )
          } else {
            if (item.config) {
              if (!configObj.find((se) => se.key == item.config.key)) {
                configObj.push({ key: item.config.key, show: item.config.show })
              }

              item.config.subConfig?.forEach((e) => {
                if (!configObj.find((se) => se.key == e.key)) {
                  configObj.push({ key: e.key, show: e.show })
                }
              })
            }
          }
        })

        // console.log('defaultRequest', defaultRequest)
        setConfigResult(configObj)

        setSchema(response?.forms)
      } else {
        doneLoading()
        window.location.href = '/'
      }
    } catch (e) {
      console.log(e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleChange = (show, key) => {
    // console.log('key : ', key, 'show : ', show)
    let datas = cloneDeep(configResult)

    let index = datas.findIndex((e) => e.key == key)
    if (index >= 0) {
      datas[index].show = show
    } else {
      datas.push({ key: name, show: show })
    }
    var coodinatorKey = ''
    if (key == 'coodinatorSummary2' && show) {
      coodinatorKey = 'coodinatorSummary'
    } else if (key == 'coodinatorSummary' && show) {
      coodinatorKey = 'coodinatorSummary2'
    }

    // console.log('coodinatorKey : ', coodinatorKey)

    if (!isEmpty(coodinatorKey)) {
      index = datas.findIndex((e) => e.key == coodinatorKey)
      if (index >= 0) {
        datas[index].show = false
      } else {
        datas.push({ key: name, show: false })
      }
    }

    // console.log('datas : ', datas)
    setConfigResult(datas)
  }

  const onSubmit = async () => {
    setIsSaveLoading(true)
    startLoading()
    setIsShowConf(false)
    try {
      let request = {
        configs: configResult,
      }

      const response = await SaveDashboardSetting(request)
      console.log(response)
      if (response.success) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 10000,
        })
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 10000,
      })
    }
    doneLoading()
    setIsSaveLoading(false)
  }

  const renderRows = (rows, index, size, rsize) => {
    const MD_LG = size ? rsize : 24
    let form

    if (rows.subForms?.length > 0) {
      form = subForms(rows.subForms)
    } else {
      switch (rows.name) {
        case 'profile':
          form = <Profile />
          break
        case 'projectCost':
          form = <ProjectCost onSettingChange={handleChange} config={rows.config} />

          break
        case 'coodinatorSummary':
          form = (
            <>
              <UpDownStreamWidget
                onSettingChange={handleChange}
                dashBoardName={'coodinatorSummary'}
                config={rows.config}
                configResult={configResult}
              />
            </>
          )

          break
        case 'coodinatorSummary2':
          form = (
            <>
              <UpDownStreamWidget
                onSettingChange={handleChange}
                dashBoardName={'coodinatorSummary2'}
                config={rows.config}
                configResult={configResult}
              />
            </>
          )

          break
        case 'userSummary':
          form = (
            <>
              <UserDashboardWidget
                onSettingChange={handleChange}
                // userType={'user'}
                config={rows.config}
              />
            </>
          )
          break
        case 'statusProposalProject': //โครงการอยู่ระหว่างเสนอ **มี Api แล้วแต่ยังไม่เปิดใช้งาน
          form = <ProposalProjectList onSettingChange={handleChange} config={rows.config} /> //ไม่ใช่ตาราง
          break
        case 'statusOngoingProject': //โครงการอยู่ระหว่างการดำเนินการ **มี Api แล้วแต่ยังไม่เปิดใช้งาน
          form = <OngoingProjectList onSettingChange={handleChange} config={rows.config} /> //ไม่ใช่ตาราง
          break
        case 'allProject': //โครงการทั้งหมด
          form = <AllProject onSettingChange={handleChange} config={rows.config} />
          break
        // case 'waitingForReview': // ยังเป็น mock อยู่
        //   form = <WaitingForReview onSettingChange={handleChange} config={rows.config} />
        //   break
        case 'waitScrutinize': //โครงการที่รอกลั่นกรอง
          form = <WaitScrutinize onSettingChange={handleChange} config={rows.config} />
          break
        case 'waitScrutinizeDep6': //โครงการที่รอกลั่นกรองเชิงประเด็น(สำนัก6)
          form = <WaitScrutinizeDep6 onSettingChange={handleChange} config={rows.config} />
          break
        // case 'waitScrutinizeMulti': //รายการกลั่นกรองหลายโครงการ **มี Api แล้วแต่ยังไม่เปิดใช้งาน
        //   form = <MultiReviewGroup isNoSidebar />
        //   break
        case 'multiApproveReviewer': //รายการที่รออนุมัติผู้ทรงคุณวุฒิสำหรับกลั่นกรองทางวิชาการหลายโครงการ **มี Api แล้วแต่ยังไม่เปิดใช้งาน
          form = <MultiApproveReviewerGroup onSettingChange={handleChange} config={rows.config} />
          break

        // case 'findBudgetYear': // ยังเป็น mock อยู่
        //   form = (
        //     <FindBudgetYear
        //
        //       onSettingChange={handleChange}
        //       config={rows.config}
        //     />
        //   ) //ไม่ใช่ตาราง
        //   break
        case 'waitForReviewer': //โครงการที่รอกลั่นกรองทางวิชาการ (สำหรับผู้ทรง)
          form = <WaitForReviewer onSettingChange={handleChange} config={rows.config} />
          break
        case 'projectStatusPending': //โครงการรอดำเนินการ
          form = <ProjectStatusPending onSettingChange={handleChange} config={rows.config} />
          break

        // case 'projectStatusInProgress': // ยังเป็น mock อยู่
        //   form = <ProjectStatusInProgress onSettingChange={handleChange} config={rows.config} />
        //   break
        // case 'searchSubProject':  // ยังเป็น mock อยู่
        //   form = (
        //     <SearchSubProject
        //       onSettingChange={handleChange}
        //       config={rows.config}
        //     />
        //   )
        //   break
        case 'notification': //แจ้งเตือน **มี Api แล้วแต่ยังไม่เปิดใช้งาน
          form = (
            <Notification
              height={rows.height}
              expanded={rows.expanded}
              onSettingChange={handleChange}
              config={rows.config}
            />
          ) //ไม่ใช่ตาราง
          break
        case 'contractStatusWait': //ข้อเสนอโครงการที่รอทำสัญญา/ข้อตกลง
          form = <ContractStatusWait onSettingChange={handleChange} config={rows.config} />
          break
        case 'waitScreeningInitial': //โครงการที่รอคัดกรองขั้นต้น
          form = <WaitScreeningInitial onSettingChange={handleChange} config={rows.config} />
          break
        case 'waitScreening': //โครงการที่รอคัดกรอง
          form = <WaitScreening onSettingChange={handleChange} config={rows.config} />
          break
        case 'waitScreeningDepartment6': //โครงการที่รอกลั่นกรองเชิงประเด็น(สำนัก6)
          form = <WaitScreeningDepartment6 onSettingChange={handleChange} config={rows.config} />
          break
        case 'expertWaitScrutinizeApproval': //โครงการที่รออนุมัติผู้ทรงคุณวุฒิสำหรับกลั่นกรองทางวิชาการ
          form = (
            <ExpertWaitScrutinizeApproval onSettingChange={handleChange} config={rows.config} />
          )
          break
          // case 'subProject':
          //   form = <SubProject />
          //   break
          break
        case 'approveProject': //รายการที่รออนุมัติ
          form = (
            <ApprovalBudget
              enableMulti={rows.isEnableMulti}
              onSettingChange={handleChange}
              config={rows.config}
            />
          )
          break
        // case 'approvalBudget':
        //   form = <ApprovalBudget enableMulti={true} />
        //   break
        // case 'approveWithdrawReviewDashboard': // **มี Api แล้วแต่ยังไม่เปิดใช้งาน
        //   form = (
        //     <ApproveWithdrawReviewDashboard onSettingChange={handleChange} config={rows.config} />
        //   )
        //   break
        // case 'approveWithdrawReviewProjectDashboard': //ยังเป็น mock อยู่
        //   form = (
        //     <ApproveWithdrawReviewProjectDashboard
        //       onSettingChange={handleChange}
        //       config={rows.config}
        //     />
        //   )
        //   break
        case 'waitContractCenterReview': //รายการโครงการที่รอตรวจสอบ
          form = <WaitContractCenterReview onSettingChange={handleChange} config={rows.config} />
          break
        case 'waitReviewToClose': //โครงการ รอตรวจสอบปิดโครงการ
          form = <WaitReviewToClose onSettingChange={handleChange} config={rows.config} />
          break
        default:
          break
      }
    }

    return (
      <Col xs={24} sm={24} md={MD_LG} lg={MD_LG} key={index}>
        {form}
      </Col>
    )
  }

  const subForms = (forms) => {
    return forms?.map((item, index) => {
      return renderRows(item, index, forms.length, item.col)
    })
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      {isSaveLoading && <OverlayLoader />}

      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <Row style={{ marginBottom: 100 }}>
          <>
            {schema?.dashBoardList &&
              schema.dashBoardList?.map((rows, index) => {
                return (
                  <Row key={index}>
                    <>{renderRows(rows, index)}</>
                  </Row>
                )
              })}
          </>
        </Row>
        <div
          style={{
            zIndex: 101,
            paddingRight: 20,
            marginLeft: -5,
            bottom: 0,
            paddingTop: 20,
            paddingBottom: 30,
            position: 'fixed',
            backgroundColor: 'whitesmoke',
            textAlign: 'right',
            width: '92%',
          }}
        >
          <SaveButton
            style={{ minWidth: 120 }}
            onClick={() => {
              setIsShowConf(true)
            }}
            disabled={isLoading}
          >
            บันทึก
          </SaveButton>
          <CancelButton
            style={{ minWidth: 120, marginLeft: 20 }}
            onClick={() => {
              // handelGetSchemaDashboard()
              window.location.href = pathname.dashboardRoot
            }}
            disabled={isLoading}
          >
            ยกเลิก
          </CancelButton>
        </div>

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isShowConf}
          size="sm"
          detail={
            <div style={{ marginTop: 10, paddingTop: -10 }}>ยืนยันบันทึกการตั้งค่าหน้าหลัก</div>
          }
          onCancle={() => setIsShowConf(false)}
          onConfirm={onSubmit}
        />
      </div>
    </>
  )
}
